<!-- Side panel pattern of season-admin: fixed under the 56px top bar, slid out when closed. Full width
     on a phone. Closed it is also inert and invisible, so its buttons are not focusable and screen
     readers skip it. Visibility is transitioned on closing only: it then waits for the slide to finish,
     while on opening it must be visible at once or the close button cannot take focus. Tailwind 4's
     translate-x-full sets translate, not transform, so that is what slides. Inert under the link editor too. -->
<aside id="integration-drawer" aria-labelledby="integration-drawer-title"
       class="fixed bottom-0 right-0 top-[56px] z-[850] flex w-full max-w-full flex-col border-l border-[var(--app-border)] bg-[var(--app-surface)] text-[13px] text-[var(--base-text-alt-dark)] shadow-[-4px_0_20px_var(--shadow)] duration-300 sm:w-[440px]"
       [ngClass]="open() ? 'transition-[translate]' : 'invisible translate-x-full transition-[translate,visibility]'"
       [attr.inert]="open() && !linkEditorOpen() ? null : ''">
  <div class="flex items-start justify-between gap-3 px-6 pt-5">
    <div class="flex min-w-0 flex-col gap-1">
      <!-- A div, not an h2: the global h2 rule overrides the Tailwind size. -->
      <div id="integration-drawer-title" role="heading" aria-level="2" class="text-lg font-semibold text-[var(--primary-dark)]">Integration status</div>
      <p class="m-0 break-words">{{ subtitle() }}</p>
    </div>
    <button #closeButton type="button" aria-label="Close integration status" (click)="close()"
            class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full hover:bg-[var(--app-hover)]">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </div>

  <div role="tablist" aria-label="Integration status views" class="mx-6 mt-4 flex gap-1 rounded-lg bg-[var(--app-base)] p-1">
    <button type="button" role="tab" id="integration-tab-field" aria-controls="integration-panel"
            [attr.aria-selected]="tab() === 'field'" (click)="selectTab('field')"
            class="h-10 flex-1 rounded-md text-[13px]"
            [ngClass]="tab() === 'field' ? 'bg-[var(--app-surface)] font-semibold text-[var(--primary-dark)] shadow-sm' : 'font-medium'">This field</button>
    <button type="button" role="tab" id="integration-tab-all" aria-controls="integration-panel"
            [attr.aria-selected]="tab() === 'all'" (click)="selectTab('all')"
            class="h-10 flex-1 rounded-md text-[13px]"
            [ngClass]="tab() === 'all' ? 'bg-[var(--app-surface)] font-semibold text-[var(--primary-dark)] shadow-sm' : 'font-medium'">All integrations</button>
  </div>

  <div id="integration-panel" role="tabpanel" [attr.aria-labelledby]="tab() === 'field' ? 'integration-tab-field' : 'integration-tab-all'"
       class="min-h-0 flex-1 overflow-y-auto px-6 py-4">
    <app-integration-this-field *ngIf="tab() === 'field'" [status]="status()" [context]="context()" [linksFailed]="linksFailed()"
                                [loading]="loading()" [failed]="failed()" (retry)="retry.emit()"></app-integration-this-field>
    <app-integration-all *ngIf="tab() === 'all'" [overview]="overview()" [loading]="overviewLoading()"
                         [failed]="overviewFailed()" (retry)="loadOverview()"></app-integration-all>
  </div>

</aside>
